import { render, staticRenderFns } from "./TeamESCPage.vue?vue&type=template&id=b99bce86&"
import script from "./TeamESCPage.vue?vue&type=script&lang=js&"
export * from "./TeamESCPage.vue?vue&type=script&lang=js&"
import style0 from "./TeamESCPage.vue?vue&type=style&index=0&id=b99bce86&prod&lang=scss&"
import style1 from "./TeamESCPage.vue?vue&type=style&index=1&id=b99bce86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports